import React from "react"
import classnames from "@utils/classnames"
import styles from "./video.module.scss"

const Video = React.forwardRef(({ inline, children, ...props }, ref) => {
  const inlineProps = inline
    ? {
        preload: "auto",
        playsInline: true,
        ["webkit-playsinline"]: "true",
        ["x5-video-player-type"]: "h5" /*让video开启同层H5播放器*/,
        ["x5-video-player-fullscreen"]: "true" /*设置为 true 是防止横屏*/,
      }
    : {}
  return (
    <video ref={ref} {...inlineProps} {...props}>
      {children}
    </video>
  )
})

Video.displayName = "Video"
export default Video
